export default "__VITE_ASSET__NiUPdKgy__"